import {
	type DefaultLinkProps,
	Heading,
	Icon,
	Link,
	type LinkProps,
	Text
} from "@pamperedchef/design-system";
import { RichText } from "@/composites/foundation";
import type { HeadingTag } from "@/app/utilities/types";

import * as sharedStyles from "../shared.module.scss";
import * as styles from "./PartyDetails.module.scss";

export interface PartyDetailsProps<LinkComponentProps = DefaultLinkProps> {
	headline?: string;
	titleTag?: HeadingTag;
	location?: string;
	date?: string;
	disclaimer?: string;
	cta?: LinkProps<LinkComponentProps>;
}

/**
 * PartyDetails component
 */
export function PartyDetails<LinkComponentProps = DefaultLinkProps>({
	headline,
	titleTag = "h4",
	location,
	date,
	disclaimer,
	cta
}: PartyDetailsProps<LinkComponentProps>): JSX.Element {
	return (
		<div className={styles["party-details"]}>
			<div className={sharedStyles["details__content"]}>
				<div className={sharedStyles["details__logo-container"]}>
					<Icon
						name="PartyColor"
						className={sharedStyles["details__logo"]}
						width={40}
						height={40}
					/>
				</div>

				<div>
					{headline && (
						<Text
							styledAs="eyebrow-1"
							className={styles["party-details__eyebrow"]}
						>
							{headline}
						</Text>
					)}

					{location && date && (
						<Heading tag={titleTag}>
							{location} on {date}
						</Heading>
					)}

					<RichText
						content={disclaimer || ""}
						className={sharedStyles["details__legend"]}
					/>
				</div>
			</div>
			{cta && (
				<div>
					<Link<LinkComponentProps>
						{...cta}
						className={styles["party-details__cta"]}
						kind="primary"
					/>
				</div>
			)}
		</div>
	);
}
